import tempMeeApi from '../../../apis/tempMee';

/**
 * Fetches recommended rates for an office from the API.
 *
 * @param {string} officeId - Office (dentist) id
 * @returns {Promise<import('../types/RecommendedRates.api').IRecommendedRatesApiResponse>} Recommended rates keyed by profession
 */
export const getRecommendedRates = async (officeId) => {
  const response = await tempMeeApi.get('admin/jobs/average-rate', {
    params: { officeId },
  });
  return response.data;
};
